import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FormBaixoAm from './form_baixo_amazonas';
import FormMilhas from './form_123_milhas';
import FormAlertaMulher from './form_alerta_mulher';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/baixo-am" element={<FormBaixoAm/>} />
        <Route path="/123-milhas" element={<FormMilhas/>} />
        <Route path="/alerta-mulher" element={<FormAlertaMulher/>} />
      </Routes>
    </Router>
  );
}

export default App;